import { IMenuItem } from "../models";
import { ROUTES } from "./routes";
export const MENU_LIST: IMenuItem[] = [
	{
		route: ROUTES.centreOperations,
		label: "Centre Operations",
		iconUrl: "images/svg/centre-grey-outline.svg",
		selectedIconUrl: "images/svg/centre-blue-filled.svg"
	},
	{
		route: ROUTES.doctorAdmin,
		label: "Doctor Admin",
		iconUrl: "images/svg/medical-services-grey-outline.svg",
		selectedIconUrl: "images/svg/medical-services-blue.svg"
	},
	{
		label: "Telehealth",
		iconUrl: "images/svg/phone-ring.svg",
		selectedIconUrl: "images/svg/phone-ring.svg",
		children: [
			{
				route: ROUTES.telehealthCentres,
				label: "Centres",
				iconUrl: "images/svg/phone-grey-outline.svg",
				selectedIconUrl: "images/svg/phone-blue.svg"
			},
			{
				route: ROUTES.telehealthQueue,
				label: "Queue",
				iconUrl: "images/svg/multiple-actions-time.svg",
				selectedIconUrl: "images/svg/multiple-actions-time-selected.svg"
			},
			{
				route: ROUTES.telehealthDoctors,
				label: "Doctors",
				iconUrl: "images/svg/telehealth-doctors.svg",
				selectedIconUrl: "images/svg/telehealth-doctors-selected.svg"
			},
			{
				route: ROUTES.telehealthSchedules,
				label: "Schedules",
				iconUrl: "images/svg/phone-grey-outline.svg",
				selectedIconUrl: "images/svg/phone-blue.svg"
			}
		]
	},
	{
		route: ROUTES.auditLogs,
		label: "Audit Logs",
		iconUrl: "images/svg/receipt-long-grey-outline.svg",
		selectedIconUrl: "images/svg/receipt-long-blue.svg"
	},
	{
		label: "Our Medical",
		iconUrl: "images/svg/cornerstone.svg",
		selectedIconUrl: "images/svg/cornerstone.svg",
		children: [
			{
				route: ROUTES.ourmedicalBlogs,
				label: "Blogs",
				iconUrl: "images/svg/article-grey-outline.svg",
				selectedIconUrl: "images/svg/article-blue.svg"
			}
		]
	},
	{
		label: "Our Sage",
		iconUrl: "images/svg/oursage.svg",
		selectedIconUrl: "images/svg/oursage.svg",
		children: [
			{
				route: ROUTES.oursageBlogs,
				label: "Blogs",
				iconUrl: "images/svg/article-grey-outline.svg",
				selectedIconUrl: "images/svg/article-blue.svg"
			},
			{
				route: ROUTES.oursageLogs,
				label: "Logs",
				iconUrl: "images/svg/article-grey-outline.svg",
				selectedIconUrl: "images/svg/article-blue.svg"
			}
		]
	},
	{
		route: ROUTES.holidays,
		label: "Holiday Admin",
		iconUrl: "images/svg/calendar_grey_outline.svg",
		selectedIconUrl: "images/svg/calendar-blue.svg"
	},
	{
		route: ROUTES.clinicSettings,
		label: "Clinic Settings",
		iconUrl: "images/svg/settings-grey-outline.svg",
		selectedIconUrl: "images/svg/settings-blue.svg"
	},
	{
		route: ROUTES.appVersions,
		label: "App Versions",
		iconUrl: "images/svg/settings-grey-outline.svg",
		selectedIconUrl: "images/svg/settings-blue.svg"
	}
];
